(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artist-newsletter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',async(event)=>{
    const form=event.target;
    if(!form.matches('.artist-signup'))return;
    event.preventDefault();
    if(form.dataset.busy==='true'||!form.reportValidity())return;
    const button=form.querySelector('button[type="submit"]'),status=form.querySelector('[role="status"]');
    const email=form.elements.email.value.trim(),artist=form.dataset.artist;
    const signature=email.toLowerCase()+'|'+artist;
    if(form.dataset.signature!==signature){form.dataset.requestId=crypto.randomUUID();form.dataset.signature=signature;}
    form.dataset.busy='true';button.disabled=true;form.setAttribute('aria-busy','true');status.textContent='';
    try{
      const response=await fetch(form.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',body:JSON.stringify({id:form.dataset.requestId,email,artist,consent:form.elements.consent.checked,website:form.elements.website.value})});
      const data=await response.json();
      if(!response.ok||!data.ok)throw Error(data.message||form.dataset.error);
      status.textContent=data.message;form.reset();delete form.dataset.signature;delete form.dataset.requestId;
    }catch(error){status.textContent=error.message||form.dataset.error;}
    finally{delete form.dataset.busy;button.disabled=false;form.removeAttribute('aria-busy');}
  });
  } catch(e) { console.error(e); }
})();

})();
